var map = {
	"./404/404": "0d48",
	"./404/404.vue": "0d48",
	"./home/Home": "5c28",
	"./home/Home.vue": "5c28",
	"./home/img/marker_search.png": "8770",
	"./home/img/patt.hiro": "ddb7",
	"./home/img/pattern-silhouette.patt": "6d19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9d9d";